"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandaloneAdPlugin = void 0;
const base_1 = require("../base");
class StandaloneAdPlugin extends base_1.BasePlugin {
    generateMarkup(config) {
        const { zone, refreshRate } = config;
        return this.generateSlotMarkup({
            slotName: 'standalone-ad',
            slotConfig: { zone, refreshRate },
        });
    }
}
exports.StandaloneAdPlugin = StandaloneAdPlugin;
//# sourceMappingURL=index.js.map